import { Box, Container, Center, Loader, Text} from '@mantine/core';
import { Outlet } from 'react-router';
import AppHeader from './components/AppHeader';
import Home from './pages/Home/Home';
import AppFooter from './components/AppFooter';
import StickyFooter from './components/StickyFooter';
import { useMediaQuery } from '@mantine/hooks';
import ScrollToTop from './components/ScrollToTop';
import { useEffect, createContext, useState } from 'react';
import { App as CapacitorApp } from '@capacitor/app';
import { useNavigate, useLocation } from 'react-router-dom';
import { is_mobile_view } from './config';
import { api } from "./services/master.service";
import { Maintenance } from "./pages/Errors/Maintenance";
import { Capacitor } from '@capacitor/core';

export const CartContext = createContext(undefined);

function App() {
  let isMobileScreen = useMediaQuery('(max-width: 768px)');
  isMobileScreen = is_mobile_view ? is_mobile_view : isMobileScreen;
  const [cartItemCount, setCartItemCount] = useState(0);
  const [search, setSearch] = useState('');
  console.log(cartItemCount);
  const location = useLocation();
  const navigate = useNavigate();
  const [maintenanceInfo, setMaintenanceInfo] = useState(null);
  const [loadingMaintenance, setLoadingMaintenance] = useState(true);


  
useEffect(() => {
  api.get_website_maintenance()
    .then((response) => {
      if (response.success && response.data) {
        setMaintenanceInfo(response.data);
      } else {
        setMaintenanceInfo(null);
      }
      setLoadingMaintenance(false);
    })
    .catch(() => {
      setLoadingMaintenance(false);
    });
}, []);
  useEffect(() => {
    console.log(location.pathname);

    CapacitorApp.addListener('backButton', ({ canGoBack }) => {
      console.log('Back button pressed', canGoBack, location.pathname);
      // if (location.pathname == '/') {
      //   CapacitorApp.exitApp();
      // } else {
      //   console.log("hey");
      //   window.history.back();
      // }
      if (!canGoBack) {
        CapacitorApp.exitApp();
      } else {
        navigate(-1);
      }
    });
  }, []);

 if (loadingMaintenance) {
  return (
    <Center style={{ height: "100vh", flexDirection: "column" }}>
      <Loader size="lg" />
      <Text mt="sm" size="md" c="dimmed">Loading...</Text>
    </Center>
  );
}

if (maintenanceInfo) {
  const { site_status, maintenance_type, reason, etd_maintenance_time, created_date } = maintenanceInfo;
  const isStopped = site_status === "stopped";

  // Website maintenance rules
  const showWebsiteMaintenance =
    isStopped && (maintenance_type === "website" || maintenance_type === "both");
  const showappMaintenance =
    isStopped && (maintenance_type === "app" || maintenance_type === "both");

  if (Capacitor.getPlatform() === 'android')
  {
    if (showappMaintenance) {
      return (
        <Maintenance
          reason={reason}
          minutes={etd_maintenance_time}
          created_date={created_date}
           maintenance_type={maintenance_type}   // ✔ added
          platform="app" 
        />
      );
    }
  }
  else 
  {
    if (showWebsiteMaintenance) {
      return (
        <Maintenance
          reason={reason}
          minutes={etd_maintenance_time}
          created_date={created_date}
          maintenance_type={maintenance_type}   // ✔ added
          platform="web" 
        />
      );
    }
  }
  
}

  return (
    <CartContext.Provider value={{ cartItemCount, setCartItemCount, search, setSearch }}>
      <div className="App">
        <ScrollToTop />
        <AppHeader />
        <Outlet />
        <AppFooter />
        {isMobileScreen ? (
          <Box
            style={{
              position: 'fixed',
              bottom: '0',
              width: '100%',
              zIndex: 10,
            }}
          >
            <StickyFooter />
          </Box>
        ) : (
          <></>
        )}
      </div>
    </CartContext.Provider>
  );
}

export default App;
